export default {
  path: '/company-preferences',
  name: 'r_company-preferences',
  meta: {
    middlewares: {
      auth: null,
      permission: 'COMPANY_PREFERENCES',
    },
  },
  component: () => import('../../components/company-preferences/Preferences'),
  children: [
    {
      path: ':category',
      name: 'r_company-preference-category',
      meta: {
        middlewares: {
          auth: null,
          permission: 'COMPANY_PREFERENCES',
        },
      },
      component: () => import('../../components/company-preferences/PreferenceCategory'),
      children: [
        {
          path: ':preferenceId',
          name: 'r_set-company-preference',
          meta: {
            middlewares: {
              auth: null,
              permission: 'COMPANY_PREFERENCES',
            },
          },
          component: () => import('../../components/company-preferences/SetPreference'),
        },
      ],
    },
  ],
};
